/**
 * Entry point for the legal pages (privacy, terms).
 *
 * Deliberately not main.ts: those pages have no form, no counter, and no ticker, so
 * loading main.ts would fetch /api/counter and /ticker.json for nothing on every view.
 *
 * Shares styles.css, so the legal pages inherit the locked brand tokens and cannot
 * drift from the landing page.
 */

import "./styles.css";
import { captureUtm, initAnalytics } from "./analytics.ts";

// Someone can land on /privacy from an ad; keep the attribution.
captureUtm();

const year = document.querySelector<HTMLElement>("[data-year]");
if (year) year.textContent = String(new Date().getFullYear());

if (document.readyState === "complete") initAnalytics();
else window.addEventListener("load", initAnalytics, { once: true });
